module.exports = __webpack_public_path__ + "img/attach.e87020ec.svg";